export default __webpack_public_path__ + "static/media/history_1990_01.f12d518a.png";